import { render, staticRenderFns } from "./systemConfig.vue?vue&type=template&id=8260b6ec&scoped=true&"
import script from "./systemConfig.vue?vue&type=script&lang=js&"
export * from "./systemConfig.vue?vue&type=script&lang=js&"
import style0 from "./systemConfig.vue?vue&type=style&index=0&id=8260b6ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8260b6ec",
  null
  
)

export default component.exports